import React from "react";

import Button from "../../button/Button";
import useThemService from "../../../services/theme-service/ThemeService";

interface SaveButtonProps {
  disabled: boolean;
  saveButtonText?: string;
}

export default function SaveButton(props: SaveButtonProps) {
  const { themeClass } = useThemService();
  const textKey = props.saveButtonText ? props.saveButtonText : "general.save";

  return (
    <Button
      id="save"
      type="submit"
      textKey={textKey}
      className={themeClass(["btn-small"])}
      disabled={props.disabled}
    />
  );
}
